import { render, staticRenderFns } from "./company_consult.vue?vue&type=template&id=08617994&scoped=true"
import script from "./company_consult.vue?vue&type=script&lang=js"
export * from "./company_consult.vue?vue&type=script&lang=js"
import style0 from "./company_consult.vue?vue&type=style&index=0&id=08617994&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08617994",
  null
  
)

export default component.exports